// const phoneRegex = /(\+?[0-9]{2}[- ]?)?(([0-9]+[- ]?[0-9]{6,})|([0-9]{3} [0-9]{3} [0-9]{3})|([0-9]{3}-[0-9]{3}-[0-9]{3})|(\([0-9]{3}\) [0-9]{3} [0-9]{4}))/g
const phoneRegex =
  /(\+?[0-9]{2}[- ]?)?(([0-9]+[- ]?[0-9]{6,})|([0-9]{3}[ -][0-9]{3}[ -][0-9]{3})|([0-9]{3}-[0-9]{3}-[0-9]{3})|(\([0-9]{3}\)[ -][0-9]{3}[ -][0-9]{4}))/g;
const emailRegex =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/gi;
const redactRegex = /\[REDACTED:(\w+)]/g;
const urlRegex =
  /((https?:\/\/)?(www\.)?[-a-zA-Z0-9\._@\~\+~]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*))/g; // also matches emails so would need to check against email regex too
const passwordRegex = /^.{4,20}$/i;

module.exports = {
  phoneRegex,
  emailRegex,
  redactRegex,
  urlRegex,
  passwordRegex,
};
